import type { ColorName } from "@skailer-com/uikit";

export const limitedColors: readonly ColorName[] = [
  // "brand-dark",
  "new",
  "blue",
  "violet",
  "pink",
  "red",
  "yellow",
  "green",
  "cyan",
  "dark",
] as const;
